<ngx-spinner bdColor="rgba(51,51,51,0.55)"
                 size="medium"
                 color="#fff"
                 type="line-spin-clockwise-fade"
                 [fullScreen]="false">
    <p class="loading">{{ 'general.loading' | translate }}...</p>
</ngx-spinner>
<div class="modal-header navbar-alertia">
        <h4 class="modal-title">{{'notification.edit_notification' | translate}}</h4>
        <button type="button" class="close" (click)="activeModal.close()">&times;</button>
</div>
<div class="modal-body">
    <div class="row">
        <div class="col-12">
            <label for="userGroup">{{'notification.send_to' | translate}}<span class="error">*</span></label><br>
            <ng-multiselect-dropdown 
                id = "userGroup"
                tabindex="0"
                placeholder="{{'general.select' | translate}}"
                [data]="groupList"
                [(ngModel)]="selectedGroups"
                [settings]="dropdownSettings"
                (onSelect)="onItemSelect($event)"
                (onSelectAll)="onSelectAll($event)"
                (onDeSelect)="onItemDeSelect($event)"
                (onDeSelectAll)="onDeSelectAll($event)"
            >
            </ng-multiselect-dropdown>
            <div id="userGroupErrE" class="error"></div>
        </div>
    </div>
    <form #editNot="ngForm" class="w-100" [formGroup]="editNotiForm" [ngClass]="{ 'was-validated': editFormSubmitted }" (ngSubmit)="editNotificationSave()" name="form">
        <div class="row mb-2">
            <div class="col-12 pt-2">
                <label for="message">{{'notification.message' | translate}}<span class="error">*</span></label>
                <input id="message" type="text" required="required" formControlName="message" maxlength="150" class="form-control"
                       [ngClass]="{ 'is-valid': message['valid']?true:false, 'is-invalid': message['invalid'] }"/>
                <ng-container *ngIf="editNotiForm.get('message').invalid && (editNotiForm.get('message').touched || editNotiForm.get('message').dirty) || editFormSubmitted">
                    <div *ngIf="editNotiForm.get('message').hasError('required')" class="error text-left">
                        {{'general.required_field' | translate}}
                    </div>
                    <div *ngIf="editNotiForm.get('message').hasError('pattern')" class="error text-left">
                        {{'general.required_field' | translate}}
                    </div>
                </ng-container>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                {{'notification.send_noti_by' | translate}}<span class="error">*</span>
            </div>
        </div>
        <div class="row mb-2">
            <div class="col-12">
                <label class="mr-2 mb-0" formArrayName="options" *ngFor="let option of optionsFormArray.controls; let i = index">
                    <input type="checkbox" [formControlName]="i" [checked]="_notiToUpdate[constants.sendOptions[i].id]">
                    {{constants.sendOptions[i].name | translate}}
                </label><br>
            </div>
            <div class="col-12 error" id="optionsErrE"></div>
        </div>
        <div class="row">
            <div class="col-12">
                <fieldset>
                    <legend class="h6 font-weight-normal">{{ 'notification.noti_scheduled_msg' | translate }}<span class="error">*</span></legend>
                    <label class="radio-inline pl-1 pr-1">
                        <input type="radio" name="schedule" formControlName="schedule" value="1" (click)="getScheduleNoti(1)" [(ngModel)]="scheduleNoti['option']">&nbsp;{{'general.yes' | translate}}
                    </label>
                    <label class="radio-inline pl-1 pr-1">
                        <input type="radio" name="schedule" formControlName="schedule" value="0" (click)="getScheduleNoti(0)" [(ngModel)]="scheduleNoti['option']">&nbsp;No
                    </label>
                </fieldset>
            </div>
        </div>
        <div class="row mb-2" id="scheduled_yes_m" hidden>
                <div class="col-3">
                    <label for="scheduleDateE" class="page-title mt-1 mr-1 text-dark mb-0">{{'general.date' | translate}}</label><br>
                    <mat-form-field class="mm-10 w-100">
                        <input id="scheduleDateE" matInput formControlName="scheduleDate" [matDatepicker]="picker1" [min]='currentDate' [(ngModel)]="selectedDate" readonly>
                        <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                        <mat-datepicker #picker1></mat-datepicker>
                    </mat-form-field>
                </div>
                <div class="col-3">
                    <label for="hour">{{'general.hour' | translate}}</label>
                    <select id="hour" class="form-control">
                        <option *ngFor="let hour of hours" [value]="hour.value" [selected]="(selectedHour!=''&& (selectedHour==hour.value))?true:false">{{hour.name}}</option>
                     </select>
                </div>
                <div class="col-12 mm-10">
                    <div id="dpErrE" class="error"></div>
                </div>
        </div>
        <hr class="hr-m">
        <div class="btn-toolbar float-right pb-2">
            <button id="cancelEdit" title="{{'general.cancel' | translate}}" class="btn btn-red btn-h-red mr-2 mb-2" (click)="activeModal.close()">
                {{'general.cancel' | translate}}
            </button>
            <button id="send_m" class="btn btn-green btn-h-green mr-2 mb-2" title="{{ 'notification.send' | translate }}" (click)="changeStatus()"> 
                {{ 'notification.send' | translate}} 
            </button>
            <button type="submit" id="update" class="btn btn-blue btn-h-blue mb-2" title="{{ 'general.update' | translate }}"> 
                {{ 'general.update' | translate}} 
            </button>
            <button id="schedule" (click)="changeStatus()" class="btn btn-green btn-h-green mb-2" title="{{ 'notification.schedule' | translate }}" hidden> 
                {{ 'notification.schedule' | translate}} 
            </button>
        </div>
    </form>
</div>        
       